import React, { useEffect, useState } from "react";
import { Header } from "../../components/SpearParts/Layouts/Header";
import Axios from "../../axios/axios";
import imageCompression from "browser-image-compression"; // Import image compression if needed
import { Footer } from "../../components/SpearParts/Layouts/Footer";
import { Link } from "react-router-dom";
import { toTitleCase } from "../../components/utils/StringUtil";
import AlertModal from "../../actions/AlertModal";
import TopNavBar from "../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../components/SpearParts/Layouts/TopSearchBar";

export default function ContactInformation() {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [image, setImage] = useState(null); // State to store the new image
  const [uploading, setUploading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  // Fetch customer details on initial load
  useEffect(() => {
    const userInfoString = sessionStorage.getItem("userInfo");

    if (userInfoString) {
      const parsed = JSON.parse(userInfoString);
      setUserInfo(parsed);
      fetchCustomerDetails(parsed.customerId);
    } else {
      setError("No user info found in sessionStorage.");
      setLoading(false);
    }
  }, []);

  // Function to fetch customer details from the backend
  const fetchCustomerDetails = async (customerId) => {
    try {
      setLoading(true);
      const response = await Axios.get(`/customer/get/${customerId}`);
      if (response.status === 200) {
        setCustomer(response.data);
        console.log(response.data);
        setImage(response.data.photo); // Set the current image on load
      } else {
        setError("Failed to fetch customer data.");
      }
    } catch (err) {
      setError("Error fetching customer details");
    } finally {
      setLoading(false);
    }
  };

  // Handle image file change (upload and compress image)
  const handleImageChange = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    try {
      // Compress the image
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1024,
      };

      const compressedFile = await imageCompression(file, options);
      const formData = new FormData();
      formData.append("image", compressedFile);

      setUploading(true);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      // Upload the image to the server
      const { data } = await Axios.post("/upload-multiple", formData, config);

      if (data && data.fileUrls && data.fileUrls.length > 0) {
        setImage({
          title: file.name,
          url: data.fileUrls[0], // Set image URL to state
        });
      } else {
        console.error("Image upload failed. No file URL returned.");
        showModal("Image upload failed");
      }
    } catch (error) {
      console.error(
        "Error uploading file:",
        error.response ? error.response.data : error.message
      );
      alert("Error uploading image");
    } finally {
      setUploading(false);
    }
  };

  // Remove the current image
  const removeImage = async () => {
    try {
      if (!customer._id || !image?.url) {
        return alert("No image to delete!");
      }

      const response = await Axios.delete(
        `/customer/delete-image/${customer._id}`
      );

      if (response.status === 200) {
        showModal(response.data.message);

        setImage(null); // Clear frontend state
      } else {
        throw new Error("Failed to delete image");
      }
    } catch (error) {
      console.error(
        "Error deleting image:",
        error.response ? error.response.data : error.message
      );
      alert("Failed to delete image!");
    }
  };

  // Handle form submission (update customer data)
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const updatedData = {
        ...customer,
        photo: image,
        bankName: customer.bankName,
        bankAddress: customer.bankAddress,
        accountNumber: customer.accountNumber,
        currency: customer.currency,
        ibanNumber: customer.ibanNumber,
        swift: customer.swift,
      };
      const response = await Axios.put(
        `/customer/update/${customer._id}`,
        updatedData
      );
      console.log(updatedData);

      if (response.status === 200) {
        setCustomer(response.data);
        showModal("Customer information updated successfully!");
      }
    } catch (err) {
      setError("Failed to update customer data");
    }
  };

  if (loading) return <div>Loading...</div>;

  const showModal = (message) => {
    setModalMessage(message);
    setIsModalOpen(true);
  };

  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: "url(/images/bnr-bg.png)",
  };

  return (
    <div style={sectionStyle}>
      {/* <Header /> */}

      <div className="Main-div">
        <TopNavBar />
        <div className="TopSearchBar">
          <TopSearchBar />
        </div>
        <section className="orders contact-info">
          <div className="container">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb p-0">
                <li>
                  <a href="search-result.html" className="back">
                    <i className="fa fa-long-arrow-left" aria-hidden="true"></i>{" "}
                    &nbsp;&nbsp;
                  </a>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/account">Account</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Contact information
                </li>
              </ol>
            </nav>

            <div className="row">
              <div className="col-lg-12">
                <h3 className="text-uppercase mb-md-5 text-center">
                  Contact Information
                </h3>

                <div className="d-flex justify-content-center">
                  <h6 className="text-center mb-3">Company Logo</h6>
                </div>

                <div className="d-flex justify-content-center">
                  {image?.url ? (
                    <img
                      src={image.url}
                      alt=""
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "50%",
                        marginBottom: "10px",
                        border: "2px solid #ccc",
                      }}
                    />
                  ) : (
                    <div class="d-md-flex align-items-center mb-md-5 mb-4">
                      <img src=" " alt=" " class="mr-4 testi-img" />
                    </div>
                  )}
                </div>

                <div className="d-flex justify-content-center mt-3">
                  {/* Image upload option */}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    disabled={uploading}
                  />
                  {uploading && <div>Uploading...</div>}
                  {image?.url && (
                    <button
                      onClick={removeImage}
                      className="ml-3 btn btn-danger"
                    >
                      Remove Image
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6 offset-lg-3">
                <form onSubmit={handleSubmit}>
                  <div className="row form_Content">
                    <div className="form-group col-md-6">
                      <label htmlFor="firstname">First Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="firstname"
                        value={customer.customerName || ""}
                        onChange={(e) =>
                          setCustomer(
                            toTitleCase({
                              ...customer,
                              customerName: e.target.value,
                            })
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="lastname">Last Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="lastname"
                        value={customer.lastName || ""}
                        onChange={(e) =>
                          setCustomer(
                            toTitleCase({
                              ...customer,
                              lastName: e.target.value,
                            })
                          )
                        }
                      />
                    </div>
                  </div>

                  <div className="row form_Content">
                    <div className="form-group col-md-6">
                      <label htmlFor="email">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        value={customer.email || ""}
                        onChange={(e) =>
                          setCustomer({ ...customer, email: e.target.value })
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="phone">Phone Number</label>
                      <div className="form-row">
                        <div className="form-group col-4">
                          <select
                            id="inputState"
                            className="form-control"
                            value={customer.phoneCode || "+91"}
                            onChange={(e) =>
                              setCustomer({
                                ...customer,
                                phoneCode: e.target.value,
                              })
                            }
                          >
                            <option value="+91">+91</option>
                            <option value="+971">+971</option>
                          </select>
                        </div>
                        <div className="form-group col-8">
                          <input
                            type="text"
                            className="form-control"
                            id="phone"
                            value={customer.phoneNumber || ""}
                            onChange={(e) =>
                              setCustomer({
                                ...customer,
                                phoneNumber: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row form_Content">
                    <div className="form-group col-md-6">
                      <label htmlFor="tax-num">Gst Number</label>
                      <input
                        type="text"
                        className="form-control"
                        id="tax-num"
                        value={customer.gstNumber || ""}
                        onChange={(e) =>
                          setCustomer({
                            ...customer,
                            gstNumber: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="country">Country</label>
                      <select
                        id="country"
                        className="form-control"
                        value={customer.country || "India"}
                        onChange={(e) =>
                          setCustomer(
                            toTitleCase({
                              ...customer,
                              country: e.target.value,
                            })
                          )
                        }
                      >
                        <option value="India">India</option>
                        <option value="USA">USA</option>
                        <option value="UK">UK</option>
                      </select>
                    </div>
                  </div>

                  {/* malabarrrrrrrrrr */}

                  <div className="row form_Content">
                    <div className="form-group col-md-6">
                      <label htmlFor="bankName">Bank Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="bankName"
                        value={customer.bankName || ""}
                        onChange={(e) =>
                          setCustomer({
                            ...customer,
                            bankName: toTitleCase(e.target.value),
                          })
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="bankAddress">Bank Address</label>
                      <input
                        type="text"
                        className="form-control"
                        id="bankAddress"
                        value={customer.bankAddress || ""}
                        onChange={(e) =>
                          setCustomer(
                            toTitleCase({
                              ...customer,
                              bankAddress: e.target.value,
                            })
                          )
                        }
                      />
                    </div>
                  </div>

                  <div className="row form_Content">
                    <div className="form-group col-md-6">
                      <label htmlFor="accountNumber">Account Number</label>
                      <input
                        type="text"
                        className="form-control"
                        id="accountNumber"
                        value={customer.accountNumber || ""}
                        onChange={(e) =>
                          setCustomer({
                            ...customer,
                            accountNumber: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="currency">Currency</label>

                      <select
                        className="form-control"
                        id="currency"
                        value={customer.currency || ""}
                        onChange={(e) =>
                          setCustomer({ ...customer, currency: e.target.value })
                        }
                        required
                      >
                        <option value="">Select Currency</option>
                        <option value="AED">AED</option>
                        <option value="$Dollar">$Dollar</option>
                        <option value="₹INR">₹INR</option>
                      </select>
                    </div>
                  </div>

                  <div className="row form_Content">
                    <div className="form-group col-md-6">
                      <label htmlFor="ibanNumber">IBAN Number</label>
                      <input
                        type="text"
                        className="form-control"
                        id="ibanNumber"
                        value={customer.ibanNumber || ""}
                        onChange={(e) =>
                          setCustomer({
                            ...customer,
                            ibanNumber: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="swift">SWIFT</label>
                      <input
                        type="text"
                        className="form-control"
                        id="swift"
                        value={customer.swift || ""}
                        onChange={(e) =>
                          setCustomer({ ...customer, swift: e.target.value })
                        }
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 offset-md-6">
                      <input
                        type="submit"
                        name="submit"
                        className="form-action"
                        value="Update"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AlertModal
        isOpen={isModalOpen}
        message={modalMessage}
        onClose={() => setIsModalOpen(false)}
      />

      {/* <Footer /> */}
    </div>
  );
}
